import JSON_ from 'json_';

export function snakeToCamel(obj: Object) {
  return obj ? JSON_.parse(JSON.stringify(obj)) : obj;
}

export function camelToSnake(obj: Object) {
  return obj ? JSON.parse(JSON_.stringify(obj)) : obj;
}
